
const insertToken = (quill, tokenData,text) => {
  let index = (quill.getSelection() || {}).index;
  index = typeof index === "number" ? index : quill.getLength();
  quill.insertText(index, text+" ");
  quill.setSelection(index+text.length+1 );
};

export default insertToken;